module.exports = __webpack_public_path__ + "static/media/nodeinit2.80246678.png";